import { Component, Input, Injector, OnInit, AfterViewInit } from '@angular/core';
import { AccessRights, UsersService } from "../../../services/users.service";
declare const $;

@Component({
  selector: 'app-left-track',
  templateUrl: './left-track.component.html',
  styleUrls: ['./left-track.component.css'],
  standalone: false
})
export class LeftTrackComponent implements OnInit, AfterViewInit {
  @Input() trackingMode: boolean;

  @Input() visibleComponents: string = "objects drivers geozones";

  public showTabs: boolean = true;

  public usersService: UsersService;
  constructor(private injector: Injector) {
    this.usersService = this.injector.get(UsersService);
  }

  ngOnInit() {
    var tabsCount = 0;

    if (this.visibleComponents.indexOf("objects") >= 0) {
      if (this.visibleComponents.indexOf('objects') == 0)
        this.openTabTracking('objects');
      tabsCount++;
    }
    if (this.visibleComponents.indexOf("geozones") >= 0) {
      if (this.visibleComponents.indexOf('geozones') == 0)
        this.openTabTracking('geozones');
      tabsCount++;
    }

    if (this.visibleComponents.indexOf("drivers") >= 0) {
      if (this.visibleComponents.indexOf('drivers') == 0)
        this.openTabTracking('drivers');
      tabsCount++;
    }
    this.showTabs = tabsCount > 1;
  }
  ngAfterViewInit() {
    this.ngOnInit();
  }

  public splitterDown(): void {
    $(document).bind("mousemove", function (e: any) {
      document.getSelection().removeAllRanges();
      var leftTop = e.clientY - 90;

      var docH = $("body").height() || 0;
      var leftBottom = docH - e.clientY;
      if (leftBottom > 100 && leftTop > 200) {
        $("#topleft").css("height", leftTop + "px");
      }
    });

    $(document).on("mouseup", function (e) {
      $(document).off("mousemove");
      $(document).off("mouseup");
    });
  }
  public openTabTracking(tabName: string) {
    var x = $("#topleft .tabpage");
    for (var i = 0; i < x.length; i++)
      $(x[i]).addClass("hidden");

   if (tabName === "objects") {
  $(x[0]).addClass("flex");
} else {
  $(x[0]).removeClass("flex");
}

    x = $("#topleftbtntabs button");
    for (var i = 0; i < x.length; i++)
      $(x[i]).removeClass("active");

    $("#" + tabName + "_tab").addClass("active");

    x = $("#bottomleft .tabpage");
    for (var i = 0; i < x.length; i++)
      $(x[i]).addClass("hidden");
    $("." + tabName).removeClass("hidden");
  }
}
